(function ($) {    
    function stickyNav(){
        var $scrollTop = $(window).scrollTop();
        
		if ($scrollTop > 30) { 
			$('#masthead').addClass('sticky');
		} else {
			$('#masthead').removeClass('sticky');
		}
	};

	/* Document Ready */
	$(document).ready(function() {
        
        AOS.init({
            duration: 400,
            once: false,
            anchorPlacement: 'top-bottom'
        });
        
        /* Jarallax requirements */
        // object-fit polyfill run
        objectFitImages();

        // init Jarallax
        jarallax(document.querySelectorAll('.jarallax'), {
            disableParallax: /iPhone|iPod|Android/,
        });

        jarallax(document.querySelectorAll('.jarallax-keep-img'), {
            keepImg: true,
        });
        
        
        $('#mobile-trigger').on('click', function(e){
            e.preventDefault();
            $('#sitesearch--toggle').removeClass('active');
            $('body').removeClass('search-open');
            $('#masthead').removeClass('search-open');
            
            $(this).toggleClass('active');
            $('body').toggleClass('nav-open');
            $('#masthead').toggleClass('nav-open');
        });
        $('#sitesearch--toggle').on('click', function(e){
            e.preventDefault();
            $('#mobile-trigger').removeClass('active');
            $('body').removeClass('nav-open');
            $('#masthead').removeClass('nav-open');
            
            $(this).toggleClass('active');
            $('body').toggleClass('search-open');
            $('#masthead').toggleClass('search-open');
        });
        
        //Sticky Nav
        stickyNav();
        
        
        $( '.js-video-popup' ).magnificPopup({
            disableOn: 700,
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false
        });
        $( '.js-modal-popup' ).magnificPopup({
            type: 'inline',
            preloader: false
        });
	});
    
    let samt = 0;
    window.addEventListener('scroll', function() {
        samt <= 10 ? samt++ : AOS.refresh();
        samt <= 10 ? samt++ : stickyNav();
    });
    
    $(window).on('beforeprint', function(){
        $('img[data-src]').each(function(){
            var image = $(this);
            image.attr('src', image.attr('data-src'));
        });
    });
    
})(jQuery);